/**
 * Info Drawer Store
 * Manages the state and functionality of the info drawer
 */
export function infoDrawerStore() {
  return {
    isOpen: false,
    title: "",
    content: "",
    type: "rich_text",

    open(detail) {
      this.title = detail.title;
      this.content = detail.content;
      this.type = detail.type;
      this.isOpen = true;

      // Initialize Yotpo reviews if needed
      if (this.type === "yotpo") {
        this.$nextTick(() => {
          this.initializeYotpoReviews();
        });
      }
    },

    close() {
      this.isOpen = false;
    },

    initializeYotpoReviews() {
      // Wait for Yotpo to be available
      this.waitForYotpo().then(() => {
        if (window.Yotpo && window.Yotpo.initWidgets) {
          window.Yotpo.initWidgets();
        }
      });
    },

    waitForYotpo() {
      return new Promise((resolve) => {
        if (window.Yotpo) {
          resolve();
        } else {
          const checkYotpo = () => {
            if (window.Yotpo) {
              resolve();
            } else {
              setTimeout(checkYotpo, 100);
            }
          };
          checkYotpo();
        }
      });
    }
  };
}
